import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { Flex } from 'antd'
import { useAuth } from '../auth'
import { UPDATE_SITE } from '../user/permission'
import { SiteConnection } from '../site/components/site-overview'
import { SiteSettings } from '../site/components/site-settings'
import { SiteAllowedDomains, SiteInstallation } from '../site/components/site-installation'
import { useSite } from '../site/hooks'

export const Route = createFileRoute('/_auth/_main/websites/$siteId/settings/connection')({
    component: Connection,
})

function Connection() {
    const { siteId } = Route.useParams()
    const { can } = useAuth()
    const { data: site } = useSite(siteId)
    const showsInstallation = site?.type === 'snippet' && site.connected

    return (
        <Flex
            vertical
            gap="large"
        >
            {showsInstallation && <SiteInstallation siteId={siteId} />}
            <SiteConnection siteId={siteId} />
            {site?.connected && <SiteAllowedDomains siteId={siteId} />}
            {can(UPDATE_SITE) && <SiteSettings siteId={siteId} />}
        </Flex>
    )
}
